import { CircleAIAppShell } from "@circle-react-uikit/CircleAIAppShell";
import { DOM_IDS } from "@circle-react-uikit/CircleAIAppShell/Layout/defaults";
import type { ReactNode } from "react";

interface CanvasOnlyContentProps {
  children: ReactNode;
}

/**
 * Bypass-route canvas wrapper for iframe embeds and other routes that opt
 * out of `ShellNativeContent`. Wraps children in `CircleAIAppShell.Layout.Inset`
 * so the rounded/margined "inset chrome" applies when the AI conversation
 * panel is open — same visual treatment normal shell routes get for free via
 * `ShellNativeContent`'s own `Inset` wrapper (`Inset.Root` reads
 * `conversationPanelState` from the store and toggles 12px vertical / 16px
 * horizontal inset chrome with rounded corners and a shadow accordingly).
 *
 * The inner scroll wrapper keeps `overflow-auto` and the `h-screen → h-full`
 * descendant override that bypass routes sometimes rely on — `Inset.Body`'s
 * default `overflow-hidden` would otherwise prevent scrolling. It shares
 * `DOM_IDS.workspaceBody` with `Workspace.Body` so callers of
 * `useMemberAreaScrollContainerId` find the canvas scroller on bypass routes.
 */
export const CanvasOnlyContent = ({ children }: CanvasOnlyContentProps) => (
  <CircleAIAppShell.Layout.Inset>
    <div
      id={DOM_IDS.workspaceBody}
      data-testid="circle-ai-shell-canvas-only"
      className="flex min-h-0 flex-1 flex-col overflow-auto [&_.h-screen]:!h-full"
    >
      {children}
    </div>
  </CircleAIAppShell.Layout.Inset>
);
